import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import SignageStatusTable from './SignageStatusTable';
import SignageHistoryTable from './SignageHistoryTable';
import SignageScheduledTable from './SignageScheduledTable';
import constants from '../../../../utils/constants';
import NotificationModal from '../../../../components/MessageManager/NotificationModal';
import dustbin from '../../../../assets/icons/message-manager/dustbin.svg';

function SigangeDashboardTeacher(props) {
  const [error, setError] = useState('');
  const [summaryData, setSummaryData] = useState([]);
  const navigate = useNavigate();
  const { user } = props;
  const permissionIds = user.permissions.map((permission) => permission.id);

  if (!permissionIds.includes(constants.permissionIds.signagePlusTeacher)) {
    navigate('/forbidden');
  }
  const [notificationProps, setNotificationProps] = useState({
    icon: dustbin,
    message: 'STOP_SIGNAGE',
    description: 'STOP_SIGNAGE_DESCRIPTION',
    showSecondaryButton: true,
    primaryButtonText: 'STOP',
  });
  const modalRef = useRef(null);

  useEffect(() => {
    modalRef.current = new window.bootstrap.Modal(document.getElementById('notificationModal'));
  }, []);

  const [updateFlag, setUpdateFlag] = useState(false);

  const statusTableRef = useRef();
  const historyTableRef = useRef();
  const scheduledTableRef = useRef();

  const loadStatusTable = (loadFunction) => {
    statusTableRef.current = loadFunction;
  };

  const loadHistoryTable = (loadFunction) => {
    historyTableRef.current = loadFunction;
  };

  const loadScheduledTable = (loadFunction) => {
    scheduledTableRef.current = loadFunction;
  };

  useEffect(() => {
    let interval;
    let isMounted = true;
    const loadData = async () => {
      if (!isMounted) return;
      if (statusTableRef.current) await statusTableRef.current();
      if (historyTableRef.current) await historyTableRef.current();
      if (scheduledTableRef.current) await scheduledTableRef.current();
      interval = setTimeout(loadData, 5000);
    };
    loadData();
    return () => {
      isMounted = false;
      clearTimeout(interval);
    };
  }, []);

  return (
    <>
      <NotificationModal {...notificationProps} />
      <SignageStatusTable
        setNotificationProps={setNotificationProps}
        updateFlag={updateFlag}
        setUpdateFlag={setUpdateFlag}
        onLoadStatusTable={loadStatusTable}
        modalRef={modalRef}
      />
      <SignageScheduledTable
        setNotificationProps={setNotificationProps}
        updateFlag={updateFlag}
        setUpdateFlag={setUpdateFlag}
        onLoadScheduledTable={loadScheduledTable}
        modalRef={modalRef}
      />
      <SignageHistoryTable
        updateFlag={updateFlag}
        onLoadHistoryTable={loadHistoryTable}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(injectIntl(SigangeDashboardTeacher))
